export default "/kiban/_next/static/images/dipPartCnt-16f42c0071fb896c9b97f9b6392b2da7.png";